import { render, staticRenderFns } from "./WechatQrModal.vue?vue&type=template&id=5bf7372d&scoped=true"
import script from "./WechatQrModal.vue?vue&type=script&lang=js"
export * from "./WechatQrModal.vue?vue&type=script&lang=js"
import style0 from "./WechatQrModal.vue?vue&type=style&index=0&id=5bf7372d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf7372d",
  null
  
)

export default component.exports